export const SLUGS = {
  home: "",
  page: "/page",
  /** Internal pathname (see `routing.pathnames`); public URLs are `servicesPath` per locale. */
  services: "/services",
  servicesPath: {
    "nl-BE": "/pia-advisory",
    "fr-BE": "/pia-advisory",
    "en-BE": "/pia-advisory",
    "fr-LU": "/services",
    "de-LU": "/services",
    "en-LU": "/services",
  },
  offices: "/offices",
  expertises: "/expertises",
  targetGroups: "/for-who",
  articles: "/news",
  author: "/author",
  reviewer: "/reviewer",
  nearby: "/nearby",
  nearbyNl: "/nearby",
  municipalities: "/municipalities",
  contact: "/contact",
  contactGeneral: "/contact/general",
  contactPartner: "/contact/partner",
  contactJobs: "/contact/jobs",
  career: "/career",
  jobs: "/career/jobs",
  search: "/search",
  accountancy: "/accountancy",
  officeNl: "/kantoren",
  officeFr: "/bureaus",
  office: {
    "nl-BE": "/kantoren",
    "fr-BE": "/bureaus",
    "en-BE": "/offices",
    "fr-LU": "/bureaus",
    "de-LU": "/offices",
    "en-LU": "/offices",
  },
  audit: "/audit",
  forWho: {
    "nl-BE": "/voor-wie",
    "fr-BE": "/pour-qui",
    "en-BE": "/for-who",
    "fr-LU": "/pour-qui",
    "de-LU": "/for-who",
    "en-LU": "/for-who",
  },
};
